import { render, staticRenderFns } from "./NewProductParameter.vue?vue&type=template&id=0e20c33a&"
import script from "./NewProductParameter.vue?vue&type=script&lang=js&"
export * from "./NewProductParameter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports